import gql from 'graphql-tag'

export const GET_APP_INIT_QUERY = gql`
	query getAppInit {
		appInit {
			tenant {
				name
				tenantCode
				apiDomain
				logo {
					file {
						fileUrl
					}
				}
				note
				timezone
			}
			tenantConfig {
				instagramUrl
				ssrUrl
				contactEmail
				facebookUrl
				faqsUrl
				linkedInUrl
				tiktokUrl
				twitterUrl
				youtubeUrl
				specialtyAssociateWithDiscipline
				enableOpusAiAssistant
				matchesMinScore
			}
			mobileAppConfig {
				iosDownloadUrl
			}
			tenantContacts {
				contactType
				email
				phone
			}
			featureFlags {
				feature
				enabled
			}
		}
	}
`
